export default __webpack_public_path__ + "76b65c195e05ec50b75599c8f67b26c6.jpg";